import {createRoot} from 'react-dom/client'

import RootStore from './app/store/root-store.ts';
import {RootStoreContext} from './app/providers/root-store-provider.ts';
import {StrictMode} from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {routes} from './app/routes/root-routes.tsx';

// spy((event) => {
//     if (event.type === 'action') {
//         console.info('[SPY]', event)
//     }
// })

const rootStore = new RootStore();
const router = createBrowserRouter(routes, {
    basename: `/`,
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <RootStoreContext.Provider value={rootStore}>
            <RouterProvider router={router}/>
        </RootStoreContext.Provider>
    </StrictMode>,
)
